export default "__VITE_ASSET__CxRgb2uP__"